import React from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import { Box, Flex } from 'components/ui';
import { buttons, radii, space } from 'style/config';
import LoveIcon from 'components/ProductPage/ProductLove/LoveIcon';
import RedesignedLoveCount from 'components/ProductPage/LovesCount/RedesignedLoveCount';
import { CTA } from 'constants/constructorConstants';

const styles = {
    container: {
        backgroundColor: 'rgba(255, 255, 255, 0.5)',
        borderRadius: radii.full,
        minWidth: buttons.HEIGHT,
        minHeight: buttons.HEIGHT
    }
};

/**
 * Floating overlay on the PDP media carousel hero image that surfaces the Love
 * action and the product's loves count (when available).
 *
 * @param {object} props
 * @param {object} props.product - The current product object from Redux.
 * @param {object} props.sku - The current sku object from Redux.
 * @returns {React.ReactElement}
 */
const ProductMediaOverlay = ({ product, sku }) => (
    <Box
        position='absolute'
        top={4}
        right={-space[2]}
        zIndex={1}
    >
        <Flex
            flexDirection='column'
            alignItems='center'
            paddingTop='6px'
            paddingX={2}
            gap={1}
            css={styles.container}
        >
            <LoveIcon
                currentProduct={product}
                sku={sku}
                loveSource='productPage'
                conversionType={CTA.MOVE_TO_LOVES}
                addPadding={true}
            />
            <RedesignedLoveCount
                product={product}
                skuId={sku.skuId}
            />
        </Flex>
    </Box>
);

export default wrapFunctionalComponent(ProductMediaOverlay, 'ProductMediaOverlay');
